/**
 * SchoolBody
 * 
 * @Author: Focci
 * @Date: 2023-08-09 12:00:13
 * @Last Modified by: Focci
 * @Last Modified time: 2023-08-09 12:00:13
 */

'use client'

import PropTypes from 'prop-types'
import clsx from 'clsx'
import Tab from '@comp/Tab'
import { isArray, map } from 'lodash-es'
import { useTranslations } from 'next-intl'
import { useCallback, useState } from 'react'
import PropertyItemScoff from '../PropertyItemScoff'
import SchoolContent from './SchoolContent'

function TabItemRender({
  item = {},
  actived = false
}) {
  return (
    <div className="flex items-center gap-x-1">
      {item.label}
      <span 
        className={clsx([
          'flex items-center justify-center px-1',
          'rounded-full text-white min-w-[1rem] text-f.6',
          actived ? 'bg-primary' : 'bg-c3b'
        ])}
      >
        {item.count}
      </span>
    </div>
  )
}

function getSchools(d) {
  const nt = (n) => /^[\d]+$/.test(n)
  return map(
    isArray(d) ? d : [], 
    (item) => ({ 
      ...item,
      decile: nt(item.decile) ? parseFloat(item.decile) : item.decile,
      score: nt(item.score) ? parseFloat(item.score) : item.score,
    })
  )
}

export default function SchoolBody({
  tabOptions = [],
  schoolData = {},
}) {
  const tabValue = tabOptions[0].value
  const th = useTranslations('house')
  const [tab, setTab] = useState(tabValue)
  const [school, setSchool] = useState(getSchools(schoolData[tabValue]))
  
  const handleChange = useCallback(({ value }) => {
    setTab(value)
    setSchool(getSchools(schoolData[value]))
  }, [schoolData])
  
  return (
    <PropertyItemScoff
      title={th('schoolInfo')}
      moduleName={th('schoolInfo')}
      id="module-schoolInfo"
      titleClassName="flex-col md:flex-row !items-start"
    >
      <div className="-mt-4 mb-4">
        <Tab 
          value={tab} 
          options={tabOptions}
          onChange={handleChange}
          itemRender={TabItemRender}
          className="py-2"
          activeClassName="border-b border-b-2 border-primary"
        />
      </div>
      <SchoolContent data={school} />
    </PropertyItemScoff>
  )
}

SchoolBody.propTypes = {
  tabOptions: PropTypes.array,
  schoolData: PropTypes.object,
}
